module.exports = __webpack_public_path__ + "img/login_bg.ea63315d.png";